import { useHistory } from "react-router-dom";
import { useEffect } from "react";

export default function ScrollTop() {
	const history = useHistory();
	useEffect(() => {
		const unlisten = history.listen((location, action) => {
			if (action !== "POP") {
				window.scrollTo(0, 0);
			}
		});
		return () => unlisten();
	}, []);
	return null;
}
